import useSWR from 'swr';

export interface AuditEvent {
  id: number;
  at: string;
  actor: string;
  action: string;
  target?: string;
  ip?: string;
  user_agent?: string;
  details?: unknown;
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then((r) => {
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  });

export function useAudit(filters: { actor?: string; action?: string; since?: string; limit?: number }) {
  const params = new URLSearchParams();
  if (filters.actor) params.set('actor', filters.actor);
  if (filters.action) params.set('action', filters.action);
  if (filters.since) params.set('since', filters.since);
  if (filters.limit) params.set('limit', String(filters.limit));
  const qs = params.toString();
  return useSWR<AuditEvent[]>(`/api/admin/audit${qs ? '?' + qs : ''}`, fetcher);
}
